<template>
  <transition name="o-transition__modal">
    <CallCenterAEDModal
      v-if="showModal"
      @close="closeModal"
      class="c-aed-ownerChange"
    >
      <div slot="header">
        <h2 class="o-heading o-heading--size-2 o-heading--border">
          {{ translationsOwnerModalCancel.cancelChangeOfOwner }}
        </h2>
      </div>
      <div slot="body">
        <div v-if="cancelStep === 1" class="o-grid o-grid--gutter-normal">
          <div class="o-grid__group">
            <div class="o-grid__item o-grid__item--12">
              <CallCenterAEDownerOtherAEDCancel></CallCenterAEDownerOtherAEDCancel>
            </div>
          </div>
        </div>
        <div class="o-grid o-grid--gutter-normal" v-if="cancelStep === 2">
          <div class="o-grid__group">
            <div class="o-grid__item o-grid__item--12">
              <h4
                class="c-aed-adminChange__text-label o-heading o-heading--size-4"
              >
                {{ translationsOwnerModalCancel.moveCancelled }}
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="o-grid o-grid--gutter-small">
          <div class="o-grid__group">
            <div
              class="c-aed-ownerChange__footer-item o-grid__item o-grid__item--grow-0"
              v-if="cancelStep === 1"
            >
              <button
                class="o-button"
                :disabled="pendingFadderSelectedItems.length === 0"
                @click="handleAEDmoveCancel"
              >
                {{ confirmButtonText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </CallCenterAEDModal>
  </transition>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import CallCenterAEDownerOtherAEDCancel from "@/components/AED/aed-ownerOtherAEDCancel.vue";
export default {
  data() {
    return {
      section: "assignee",
      name: "Skift ejer",
      showModal: false
    };
  },
  components: {
    CallCenterAEDownerOtherAEDCancel
  },
  props: {
    showOwnerChangeCancel: { type: Boolean, required: true }
  },
  computed: {
    ...mapGetters("aed", [
      "profileAedCount",
      "currentAED",
      "parameters",
      "pendingFadder"
    ]),
    ...mapState("owners", [
      "newOwner",
      "cancelStep",
      "pendingFadderItems",
      "pendingFadderSelectedItems"
    ]),
    ...mapState("translations", {
      translationsOwnerModal: "ownerModal",
      translationsOwnerModalCancel: "ownerModalCancel",
      translationsCustom: "custom"
    }),
    confirmButtonText() {
      if (this.pendingFadderSelectedItems.length > 0) {
        return `${this.translationsOwnerModalCancel.yesCancelThe} ${
          this.pendingFadderSelectedItems.length
        } ${this.translationsOwnerModalCancel.selectedAEDs}`;
      }
      return `${this.translationsOwnerModalCancel.yesCancelThe} ${
        this.translationsOwnerModalCancel.selectedAEDs
      }`;
    }
  },
  methods: {
    ...mapActions("owners", ["cancelMoveAEDs", "getPendingFadderItems"]),
    ...mapMutations("owners", ["resetState"]),
    closeModal() {
      this.showModal = false;
      this.$emit("close");
    },
    confirm() {
      this.handleAEDmoveCancel();
      this.closeModal();
    },
    fetchPendingFadderItems() {
      if (this.pendingFadder) {
        const payload = {
          profileId: this.pendingFadder.id
        };
        this.getPendingFadderItems(payload);
      }
    },
    handleAEDmoveCancel() {
      const payload = {
        profileId: this.pendingFadder && this.pendingFadder.id,
        getAllpayload: {
          id: this.$store.state.aed.all.id,
          parameters: this.parameters
        },
        aed: this.pendingFadderSelectedItems
      };

      this.cancelMoveAEDs(payload);
    }
  },
  watch: {
    showOwnerChangeCancel() {
      this.showModal = this.showOwnerChangeCancel;
      if (this.showModal) {
        this.fetchPendingFadderItems();
      }
    }
  },
  mounted() {
    this.fetchPendingFadderItems();
    this.$nextTick(() => {
      this.showModal = this.showOwnerChangeCancel;
    });
  },
  destroyed() {
    this.resetState();
  }
};
</script>

<style lang="scss">
@import "~svg-spritemap-webpack-plugin/sprites.scss";
.c-aed-ownerChange {
  .c-modal__body {
    margin-bottom: 40px;
  }
  .c-modal__footer {
    background-color: $s-cp-neutral-700;
    padding-top: 30px;
    padding-bottom: 40px;
  }
}
</style>
